import { postApi } from "./api_instance";

export const signIn = async ({ email, password, userType }) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/signin",
      dispatch: () => {},
      data: { email, password, user_type: userType },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
